import styled from 'styled-components'
import { rgba, transparentize } from 'polished'

export const Wrapper = styled.div<{ open: boolean | undefined }>`
  position: relative;
  grid-area: side;
  height: 100%;
  width: ${({ open }) => (open ? '390px' : '85px')};
  top: 1px;
  position: absolute;
  z-index: ${({ theme }) => theme.layers.menu};
  padding-top: 1%;
  background-color: ${({ theme }) => theme.ds.colors.white};
  font-size: 16px;
  box-shadow: 0px 8px 10px 2px rgba(0, 0, 0, 0.15);
  transition: width 0.4s;
`

export const MenuItem = styled.a<{ active?: boolean }>`
  display: flex;
  align-items: center;
  height: 54px;
  padding-left: 20px;
  margin: 0 12px;
  background-color: ${({ active, theme }) =>
    active ? transparentize(0.85, theme.ds.colors.primary600) : 'none'};
  border-radius: 8px;
  line-height: 1;
  color: ${({ active, theme }) =>
    active ? theme.ds.colors.primary600 : theme.ds.colors.neutral400};
  cursor: pointer;
  font-weight: 500;

  > div {
    height: 32px;
    margin-right: 24px;
  }

  svg {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    fill-opacity: 1;

    path {
      width: 100%;
      height: 100%;
      fill: ${({ active, theme }) =>
        active
          ? theme.ds.colors.primary600
          : rgba(theme.ds.colors.black, 0.45)};
      fill-opacity: 1;
    }
  }

  :hover {
    background-color: ${({ active, theme }) =>
      !active ? transparentize(0.9, theme.colors.lightGray) : ''};
  }
`

export const MenuLink = styled.span<{ open: boolean | undefined }>`
  overflow: hidden;
  position: relative;
  margin-left: 24px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-decoration: none;
  white-space: nowrap;
  animation: ${({ open }) => (open ? 'fadeIn 0.4s' : 'fadeOut 0.4s')};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    100% {
      opacity: 0;
    }
    0% {
      opacity: 1;
    }
  }
`
